import React from 'react'
import { useSelector } from 'react-redux';
import clsx from 'clsx';
// material ui
import { makeStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
// components
import Theme from '../../Theme.js';
import MessageButtonMulti from './sub/MessageButtonMulti';
import WidgetBar from '../../../../builder/components/WidgetBar.js'
// helpers
import { getMessage } from '../helpers.js';

const useStyles = makeStyles({
  actions: {
    // justifyContent: 'space-evenly',
    padding: '24px 0',
    justifyContent: 'space-between',
    '&:before': {
      content: '""',
      display: 'block',
    },
    '&:after': {
      content: '""',
      display: 'block',
    },
  },
  avatar: {
    position: 'absolute',
    bottom: '0',
    left: '50%',
    transform: 'translate(-50%, 50%)',
    width: props => props.avatarSize,
    height: props => props.avatarSize,
    border: '4px solid ' + Theme.bgColorLight,
    boxShadow: Theme.avatarBoxShadow,
  },
  card: {
    boxShadow: Theme.cardBoxShadow,
    marginBottom: '28px',
    position: 'relative',
  },
  guideTitle: {
    fontSize: '.75rem',
    textTransform: 'uppercase',
  },
  header: {
      position: 'relative',
      textAlign: 'center',
      backgroundColor: props => props.screen == 'desktop' ? Theme.bgColorDark : '#ffffff',
      paddingTop: props => props.headerPadding,
      paddingRight: props => props.headerPadding,
      paddingBottom: props => props.headerPadding + (props.avatarSize/2),
      paddingLeft: props => props.headerPadding,
      marginBottom: props => (props.avatarSize/2),
  },
});

export default function Message(props) {
  const [showWidgetBar, setShowWidgetBar] = React.useState(false)
  const { context, screen } = props;
  let avatarSize = 0;
  if (context.show_author_image && context.author_image) {
    avatarSize = 120;
  }
  const styleProps = {
    "avatarSize": avatarSize,
    "headerPadding": 16,
    "screen": screen,
  }
  const classes = useStyles(styleProps);
  var order;
  (screen == 'desktop') ? (order = context.desktop_order) : (order = context.mobile_order);
  const componentClasses = clsx({
    [classes.card] : true,
    "cardMobile" : screen == 'mobile' ? true : false,
  })

  var msgHeader;
  var msgText;
  if (window.mode == 'live') {
    var language = window.language;
    msgHeader = context.message_title;
    msgText = context.message_body;
  } else {
    var activeRoom = useSelector(state => state.activeRoom);
    var didEscape = useSelector(state => state.didEscape);
    var groupType = useSelector(state => state.groupType);
    var language = useSelector(state => state.language);
    var roomMessaging = useSelector(state => state.roomMessaging);
    msgHeader = getMessage("msg_title", didEscape, activeRoom, groupType, roomMessaging, language);
    msgText = getMessage("msg_body", didEscape, activeRoom, groupType, roomMessaging, language);
  }

  const handleWidgetHover = (e) => {
    if (e.type == 'mouseenter') {
      setShowWidgetBar(true);
    } else if (e.type == 'mouseleave') {
      setShowWidgetBar(false);
    }
  }

  return (
    <Card className={componentClasses + ' review-widget'} style={{ order: order }}
      onMouseEnter={window.mode == 'builder' ? handleWidgetHover : null} onMouseLeave={window.mode == 'builder' ? handleWidgetHover : null}
    >

      {context.show_author && (
      <CardContent className={classes.header} >
        {context.show_author_image && context.author_image && (
          <Avatar src={context.author_image} className={classes.avatar} />
        )}
        {(context.author_final == "guide") && (
          <Typography variant="caption" component="p" color="textSecondary" className={classes.guideTitle}>
            {context.guide_title[language] || context.guide_title["en"]}
          </Typography>
        )}
        <Typography variant="h5" component="h2">
          {context.author_name}
        </Typography>
      </CardContent>
      )}

      {context.show_message && (
      <CardContent>
        {context.show_message_title && (
        <Typography gutterBottom variant="body1" component="h2" style={{ whiteSpace: 'pre-line' }} >
          {msgHeader}
        </Typography>
        )}
        {context.show_message_body && (
        <Typography variant="body2" color="textSecondary" component="p" style={{ whiteSpace: 'pre-line' }} >
          {msgText}
        </Typography>
        )}
      </CardContent>
      )}

      {context["show_button"] && (
        <CardActions className={classes.actions} >
          {context["button_type"] == "single" && (
            <Button variant="outlined" size="large" color="primary"
              target="_blank" rel="noopener" href={context["single_link"]}
            >
              {context.button_text[language] || context.button_text["en"]}
            </Button>
          )}
          {context["button_type"] == "multi" && (
            <MessageButtonMulti
              multiLinks={context["multi_links"]}
              buttonText={context.button_text[language] || context.button_text["en"]}
            />
          )}
        </CardActions>
      )}

      {window.mode == 'builder' && showWidgetBar &&
        <WidgetBar context={context} />
      }

    </Card>
  )
}